import { Injectable } from '@angular/core';
import { FormGroup, FormControl, FormGroupDirective, NgForm, FormBuilder, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export const AUTH_PASS_MIN_LENGTH: number = 8;
export const AUTH_PASS_PATTERN: string = '^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{8,}$';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  email_label: string = 'email';
  password_label: string = 'password';
  password_confirm_label: string = 'password_confirm';

  constructor() {}

  auth_signin_form_group: FormGroup = new FormBuilder().group({
    email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
    password: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.pattern(AUTH_PASS_PATTERN),
        Validators.maxLength(50),
      ],
    ],
  });

  auth_signup_form_group: FormGroup = new FormBuilder().group({
    email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
    password: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.pattern(AUTH_PASS_PATTERN),
        Validators.maxLength(50),
      ],
    ],
    password_confirm: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.pattern(AUTH_PASS_PATTERN),
        Validators.maxLength(50),
      ],
    ],
  });

  agent_builder_form_group: FormGroup = new FormBuilder().group({
    firstname: ['', [Validators.required]],
    lastname: ['', [Validators.required]],
    email: ['', [Validators.required]],
    phone_prefix: ['', [Validators.required]],
    phone_value: ['', [Validators.required]],
  });

  organization_builder_form_group: FormGroup = new FormBuilder().group({
    business_name: ['', [Validators.required]],
    vat: ['', [Validators.required]],
    website: ['', [Validators.required]],
  });

  matcher: FormErrorStateMatcher = new FormErrorStateMatcher();

  validateForm(form_group: FormGroup): boolean {
    let valid: boolean = true;
    for (let control_name of Object.keys(form_group.controls)) {
      if (form_group.get(control_name)?.invalid) {
        valid = false;
      }
    }
    return valid;
  }
}

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const is_submitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || is_submitted));
  }
}
